import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers } from 'common/utils/sliceUtils/filterSliceUtils';

import type { RootState } from '../../app/store';

const aclEntriesSlice = createSlice({
    name: 'aclEntries',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default aclEntriesSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters } = aclEntriesSlice.actions;
export const selectFilters = (state: RootState) => state.aclEntries.filters;
